"use client";

import { getCookies } from "@/utils/common/cookiesHelper/CookiesUtills";
import { CookiesItemEnum } from "@/utils/enums/CookiesItemEnum";

import type {
  ClickDownloadApp,
  ClickMenu,
  ClickPartnership,
  ClickSocial,
} from "../interface/footerInterface";

const pushGAFooter = () => {
  const { dataLayer } = window as any;
  try {
    // done
    const ClickMenu = (eventLabel: string) => {
      if (dataLayer !== undefined) {
        const gaParam: ClickMenu = {
          event: "footer_section",
          event_action: "click_main_menu",
          event_label: eventLabel,
        };
        dataLayer.push(gaParam);
      }
    };

    // done
    const ClickDownloadApp = (eventLabel: string) => {
      if (dataLayer !== undefined) {
        const gaParam: ClickDownloadApp = {
          event: "download_app",
          event_action: "click_download_app",
          event_label: eventLabel,
        };
        dataLayer.push(gaParam);
      }
    };

    // done
    const ClickSocial = (eventLabel: string) => {
      if (dataLayer !== undefined) {
        const gaParam: ClickSocial = {
          event: "footer_section",
          event_action: "click_social",
          event_label: eventLabel,
        };
        dataLayer.push(gaParam);
      }
    };
    const ClickPartnership = () => {
      if (dataLayer !== undefined) {
        const gaParam: ClickPartnership = {
          event: "footer_section",
          event_action: "click_button",
          event_label: "contact_partnership",
        };
        dataLayer.push(gaParam);
      }
    };

    return { ClickMenu, ClickDownloadApp, ClickSocial, ClickPartnership };
  } catch (error) {
    const ga4ShowError = getCookies(CookiesItemEnum.GA4_DISPLAY_MODE_COOKIES);
    if (ga4ShowError === "true") {
      throw new Error();
    }
    return null;
  }
};

export default pushGAFooter;
